export default {
  Language: 'English',
  system: {
    homePage: {
      login: 'login',
      register: 'register',
    },
    headerMenu: {
      HomePage: "Home Page",
      ScientificData: "Scientific Data",
      PDSDataSet: "PDS DataSet",
      LunarSample: "Planetary Database ",
      WebGis: "WebGis",
      Moon: "Moon",
      Mars: "Mars",
      Planet: "Planet",
      SampleMoon: "Lunar Samples",
      SampleAsteroid: 'Asteroids Samples',
      ResourceTools: "Resource Tools",
      AboutUs: "About Us",
      PopularScience: "Popular Science",
      PlanetaryDatabaseName: "Planetary Database",
      extraterrestrial: "Extraterrestrial Samples",
    },
    infoData: {
      lastNew: "Recent News",
      more: "more",
      Roam: "Moon",
      Lunar: "Lunar",
      MoonandPlanets: "Moon and Planets",
      PopularScience: "Popular Science",
      RecentNews: "Recent News",
      DataRelease: "Data Release",
      TasksIntroduction: "Tasks Introduction",
      OngoingNews: "Ongoing News",
      LatestProduct: "Latest Product",
      NoticeandAnnouncement: "Noticeand Announcement",
      Other: "Other",
      ReleaseTime: "ReleaseTime",
      PageViews: "PageViews"
    },
    footData: {
      Name: "National Astronomical Observatories of China",
      ContactUs: "Contact Us",
      RecordNumber: "Record Number",
      WenbaoNetworkSecurityFilingNumber: "Wenbao Network Security Filing Number"
    },
    PopularScience: {
      Moon: "Moon",
      Mars: "Mars",
      ViewCount: "View Count",
      AllCategories: "AllCategories",
      DataIndex: "Data Index"
    },
    ResourceTools: {
      ResourceTools: "Resource Tools",
      ScienceProducts: "Science Products",
      ModelProducts: "Model Products",
      Books: "Books",
      NationalStandard: "National Standard"
    },

  },
  regist: {
    UserType: "UserType",
    UserName: "UserName",
    Email: "Email",
    RealName: "RealName",
    Password: "Password",
    ConfirmPassword: "ConfirmPassword",
    VerificationCode: "VerificationCode",
    Company: "Company",
    Telephone: "Telephone",
    Fax: "",
    DetailedAddress: "",
    Postcode: ""
  },
  ScientificData: {
    DataCatalog: "Data Catalog",
    ReturnHomePage: "Return HomePage",
    ScientificDataTree: "Scientific Data Tree",
    MissionIntroduction: "Mission Introduction",
    DataDeclaration: "Data Declaration",
    ReferenceAndAcknowledgement: "Reference And Acknowledgement",
    CopyrightNotice: "Copyright Notice",
    CurrentPosition: "Current Position",
    HomePage: "HomePage",
    ScientificData: "Scientific Data",
    Mars: "Planet",
    Moon: "Moon",
    Tianwen: "Tianwen-1",
    TaskModel: "Task Model",
    DataType: "Data Type",
    PublicData: "Public Data",
    ProtectedData: "Protected Data",
    CarryingPlatform: "Carrying Platform",
    DataAcquisitionTime: "Data AcquisitionTime",
    FirstReleaseTime: "First ReleaseTime",
    LatestReleaseTime: "Latest ReleaseTime",
    DataStatus: "Data Status",
    PublicAccess: "Public Access",
    AuthorizedAccess: "Authorized Access",
    Others: "Others",
    DataServiceContactInformation: "Data Service Contact Information",
    TotalReleaseBatches: "Total Release Batches",
    DataVolume: "Data Volume",
    DataFormat: "Data Format",
    DataVersion: "Data Version",
    DataProducer: "Data Producer",
    DataAceess: {
      Payload: "Payload",
      DataLevel: "Data Level",
      AdvancedSearch: "Advanced Search",
      Longitude: "Longitude",
      Latitude: "Latitude",
      DisplayonPlanetMap: "Display on PlanetMap",
      Reset: "Reset",
      DataName: "Data Name",
      StartTime: "Start Time",
      EndTime: "End Time",
      OrbitNumber: "Orbit Number",
      Search: "Search",
      ClearSearch: "Clear Search",
      DataList: "Data List",
      ReceivingStation: "Receiving Station",
      DetectionMission: "Detection Mission",
      Size: "Size",
      DataVersion: "Data Version",
      BatchDownload: "Batch Download",
      BatchFavorite: "Batch Favorite",
      DownloadNow: "Download Now",
      AddtoFavorites: "Addto Favorites",
      ExpandMore: "Expand More",
      DataAcquisition: "Data Acquisition",
      CancelFavorites: "Cancel Favorites",
      NoDataAvailable: "No Data Available",
      DataStatus: "Data Status"
    }
  },
  DetailMoon: {
    startDate: 'Data Start Date',
    endDate: 'Data End Date',
    genDate: 'Data Generation Date',
    releaseTime: 'Latest Release Time',
    pendingReview: 'Pending Review',
    applyDownload: 'Apply for Download',
    producer: 'Data Producer',
    doi: 'DOI'
  },
  Login: {
    UserName: "UserName",
    PassWord: "PassWord",
    CheckCode: "CheckCode",
    ForgottenPassword: "ForgottenPassword",
    Login: "Login",
    Cancel: "Cancel",
    PleaseLogin: "Please Login",
    NewUserRegistration: "New User Registration",
    ResetPassword: "Reset Password",
    PleaseEnterYourPassword: "Please Enter Your Password",
    Submit: "Submit",
    PleaseEnterUserAccount: "Please enter user account"
  },
  Register: {
    title: 'Register',
    userType: 'User Type',
    userTypeSci: 'Scientific Data User',
    userTypeSample: 'Sample User',
    accountLabel: 'User Account',
    accountPlaceholder: 'Your account name for login',
    nameLabel: 'Real Name',
    namePlaceholder: 'Your real name',
    phoneLabel: 'Mobile Number',
    phonePlaceholder: 'Please enter mobile number',
    emailLabel: 'Email',
    emailPlaceholder: 'Please enter email',
    companyLabel: 'Organization',
    companyPlaceholder: 'Please enter full organization name',
    idCardLabel: 'ID Number',
    pwdLabel: 'Set Password',
    pwdConfirmLabel: 'Confirm Password',
    pwdConfirmTip: 'Password 6-16 characters, case sensitive',
    codeLabel: 'Verification Code',
    codePlaceholder: 'Enter verification code',
    goLogin: 'Login with existing account'
  },
  FileData: {
    ScientificData: "Scientific Data",
    Mars: "Planet",
    FileName: "FileName",
    FileSize: "FileSize",
    Action: "Action",
    ViewDetail: "ViewDetail",
    Download: "Download"
  }
};
